import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OtpVerificationStateService {
  private _verified = false;

  public get isVerified(): boolean {
    return this._verified;
  }

  public verify(): void {
    this._verified = true;
  }

  public reset(): void {
    this._verified = false;
  }
}
